import React from 'react';

interface SnookerBallProps {
  size?: number;
  style?: React.CSSProperties;
  className?: string;
  spin?: boolean;
}

/** A red snooker ball SVG to replace the pool 8-ball emoji throughout the app */
export default function SnookerBall({ size = 32, style, className, spin = false }: SnookerBallProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'inline-block', flexShrink: 0, ...style }}
      className={className}
    >
      {/* Outer shadow */}
      <circle cx="32" cy="34" r="28" fill="rgba(0,0,0,0.25)" />
      {/* Main ball — red */}
      <radialGradient id="rball" cx="38%" cy="32%" r="62%">
        <stop offset="0%" stopColor="#ff6b6b" />
        <stop offset="45%" stopColor="#c0392b" />
        <stop offset="100%" stopColor="#7b1c11" />
      </radialGradient>
      <circle cx="32" cy="32" r="28" fill="url(#rball)" />
      {/* Specular highlight */}
      <ellipse cx="24" cy="20" rx="8" ry="5" fill="rgba(255,255,255,0.45)" transform="rotate(-20 24 20)" />
      <ellipse cx="22" cy="18" rx="3" ry="2" fill="rgba(255,255,255,0.7)" transform="rotate(-20 22 18)" />
      {spin && (
        <style>{`
          @keyframes snookerSpin {
            from { transform: rotate(0deg); transform-origin: 32px 32px; }
            to   { transform: rotate(360deg); transform-origin: 32px 32px; }
          }
        `}</style>
      )}
    </svg>
  );
}

/** Inline version for use in text / loading spinners */
export function SnookerBallSpinner({ size = 32 }: { size?: number }) {
  return (
    <div style={{ display: 'inline-block', animation: 'spin 1.5s linear infinite', lineHeight: 0 }}>
      <SnookerBall size={size} />
    </div>
  );
}
